import React from "react";
import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

import WarningIcon from "@mui/icons-material/Warning";

const DeleteConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  username,
  loading,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          p: 1,
        },
      }}
    >
      {/* HEADER */}
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={2}>
          <Avatar sx={{ bgcolor: "error.main" }}>
            <WarningIcon />
          </Avatar>

          <Typography fontWeight={700}>
            Delete User
          </Typography>
        </Box>
      </DialogTitle>

      {/* CONTENT */}
      <DialogContent>
        <Typography color="text.secondary">
          This action is permanent.
        </Typography>

        <Typography mt={1}>
          Are you sure you want to delete{" "}
          <b>@{username}</b>?
        </Typography>
      </DialogContent>

      {/* ACTIONS */}
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>Cancel</Button>

        <Button
          variant="contained"
          color="error"
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? "Deleting..." : "Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmDialog;